import _ from 'underscore';
import { selectors } from './selectors';


const regexPseudo = /::(after|before)$/;
const style = {
  position: 'relative',
  top: '-15px',
  left: '-14px',
  color: '#ffffff',
  border: '1px solid #ffffff',
  height: '20px',
  padding: '1px 9px',
  'font-size': '12px',
  'box-shadow': '0 2px 5px #a19f9d',
  'font-weight': 'normal',
  'line-height': '16px',
  'border-radius': '12px',
  'background-color': '#D83B01',
};

export function addBadgeForNewFeatures(text) {
  const pseudoElements = _.map(selectors, sel => (sel.match(regexPseudo) ? sel : `${sel}::after`));
  const styleText = _.map(style, (value, key) => `${key}: ${value}`).join('; ');
  const css = `${pseudoElements.join(', ')} {${styleText}; content: "${text}";}`;
  const styleElement = document.createElement('style');

  styleElement.appendChild(document.createTextNode(css));
  document.head.appendChild(styleElement);
}
